import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback } from 'react';

import { adminActions } from '../admin.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function MTMSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAddMTMSettings = useCallback(() => {
    dispatch(adminActions.setEditingMtmSettingsId(null));
    dispatch(adminActions.setShowMtmSettingsModal(true));
  }, [dispatch]);

  return (
    <div className="flex flex-row gap-2">
      <Button onClick={handleAddMTMSettings} variant="primary">
        Add MTM Settings
      </Button>
    </div>
  );
}
